import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const AdminLogin = () => {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(email, password);
            toast.success("Welcome back!");
            navigate("/admin");
        } catch (err) {
            const d = err?.response?.data?.detail;
            toast.error(typeof d === "string" ? d : "Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen grid place-items-center bg-bg-base px-6">
            <div className="max-w-md w-full">
                <div className="text-center mb-8">
                    <div className="text-4xl gold-text-gradient font-serif font-bold">★ Star Events</div>
                    <div className="text-xs uppercase tracking-[0.4em] text-white/60 mt-3">Admin Console</div>
                </div>
                <form onSubmit={onSubmit} data-testid="admin-login-form" className="glass-card rounded-2xl p-8 space-y-5">
                    <div className="flex items-center gap-3 text-gold mb-2">
                        <Lock size={20} /><span className="font-serif text-xl text-white">Sign in</span>
                    </div>
                    <input
                        type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                        placeholder="admin@stareventnagpur.com" data-testid="admin-email"
                        className="w-full bg-bg-base border border-white/15 rounded-lg px-4 py-3 text-white focus:border-gold focus:outline-none"
                    />
                    <input
                        type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
                        placeholder="Password" data-testid="admin-password"
                        className="w-full bg-bg-base border border-white/15 rounded-lg px-4 py-3 text-white focus:border-gold focus:outline-none"
                    />
                    <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-gold w-full inline-flex items-center justify-center gap-2">
                        {loading ? <Loader2 className="animate-spin" size={16} /> : "Sign in"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
